<template>
  <div class="c-engraving-font-image">
    <img
      :src="src"
      :alt="altText || 'Font image'"
      class="c-engraving-font-image__image"
    >
  </div>
</template>
<script>
export default {
  name:'FontImage',
  props:{
    src:{
      type:String,
      default:'',
    },
    altText:{
      type:String,
      default:'',
    }
  }
}
</script>
<style lang="scss" scoped>
	.c-engraving-font-image{
		text-align: center;
    max-width: 100%;
    &__image{
      max-height: 300px;
      max-width: 300px;
    }

	}
</style>